export function stringTrim(requestBody: any) {
    for (const [key, value] of Object.entries(requestBody)) {
        if (typeof value === 'string') {
            requestBody[key] = value.trim();
        }
    }
    return requestBody;
}
